import { useEffect, useState } from "react";
import { getGlobalBannerCookie } from "services/cookies";
import { getFilters } from "./requests";
import { STATIC_FILTERS } from "./constants";
import { mapCategoriesResponse } from "./mappers";

export const useGetFilters = () => {
  const [filters, setFilters] = useState();

  const showGlobalBanner = getGlobalBannerCookie !== "true";

  useEffect(() => {
    const queryFilters = async () => {
      try {
        const categoriesFilterResponse = await getFilters();
        const categories = mapCategoriesResponse(categoriesFilterResponse);
        const filters = {
          category: categories,
          ...STATIC_FILTERS
        };

        setFilters(filters);
      } catch (error) {
        setFilters(null);
      }
    };

    queryFilters();
  }, [showGlobalBanner]);

  return {
    filters
  };
};
